/// <reference types="@emotion/react/types/css-prop" />
import {
  ContentModule,
  ModuleProperties,
  useAnimationStates,
  useShowInstructions,
} from '@backstage-components/base';
import {css} from '@emotion/react';
import {motion} from 'framer-motion';
import {useObservableState} from 'observable-hooks';
import QRCode from 'qrcode.react';
import {FC} from 'react';
import {filter, map} from 'rxjs';
import {
  ComponentDefinition,
  InstructionSchemaType,
  SchemaType,
} from './QRCodeDefinition';

export interface IQRCodeProps extends ModuleProperties {
  size: number;
  value: string;
}

export type QRCodeComponentDefinition = ContentModule<
  'QRCode',
  IQRCodeProps & SchemaType
>;

export const QRCodeComponent: FC<QRCodeComponentDefinition> = (definition) => {
  const {id, props, style} = definition;
  const {size, value: initialValue, styleAttr, animationStates} = props;

  const {broadcast, observable} = useShowInstructions(
    ComponentDefinition.instructions,
    definition
  );
  const motionOptions = useAnimationStates(
    observable,
    broadcast,
    animationStates
  );

  const value = useObservableState(
    observable.pipe(
      filter(
        (instruction): instruction is InstructionSetUrl =>
          instruction.type === 'QRCode:setUrl'
      ),
      map((instruction) => instruction.meta.url)
    ),
    initialValue
  );
  return (
    <motion.div id={id} {...motionOptions}>
      <title id="qrcode-title">QR Code that will send you to {value}</title>
      <QRCode
        role="img"
        aria-labelledby="qrcode-title"
        renderAs="svg"
        size={size}
        value={value}
        css={css`
          border-radius: 0.5rem;
          background-color: white;
          padding: 0.5rem;
          ${style}
          flex: 0 0 auto;
          ${styleAttr}
        `}
      />
    </motion.div>
  );
};

type InstructionSetUrl = Extract<
  InstructionSchemaType,
  {type: 'QRCode:setUrl'}
>;
